/* eslint-disable */
export default {
  init() {
	$(window).on('load', function() {
			//position-fixed for header
	
	const lastSrc = $($('.video-content #iframe').attr('value')).attr('src');
	let times = 0, playY;
	if(times == 0){
		$('.play-button').click(function(){
			playY = $('.video-content iframe').attr('src', lastSrc + '&autoplay=1');
			times = 1;
			$('.video-content iframe').show();
			$('.img-cover').hide();
			$('.overlay-video').hide();
			$('.play-button').hide();
		});
	}

	$('.open-overlay').click(function(e){
		e.preventDefault();
		$('body').addClass('no-scroll');
		$('.overlay').addClass('open');
		$('.overlay-content').addClass('open');
	});
	$('.btn-close').click(function(){
		$('body').removeClass('no-scroll');
		$('.overlay').removeClass('open');
		$('.overlay-content').removeClass('open');
	});
	$('.overlay').on('click', function(e) {
	if (e.target !== this)
		return;
		$('body').removeClass('no-scroll');
		$('.overlay').removeClass('open');
		$('.overlay-content').removeClass('open');
	});
	let currentPage = 1;
	$('#load-more').on('click', function() {
		currentPage++; 
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
			action: 'load_more',
			paged: currentPage,
			},
			success: function (res) {
				var maxPagesPromise = new Promise(function(resolve) {
					setTimeout(function() {
						var maxPages = parseInt($('#max_pages').val());
						resolve(maxPages);
					}, 100);
				});
				maxPagesPromise.then(function(maxPages) {
					if (currentPage >= maxPages) {
						$('#load-more').hide();
					}
					$('.news-wrapper').append(res);
				});
			}
		});
	});
	});
	if(window.innerWidth < 992){
		$('.values-content').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: false,
			variableWidth: true,
			arrows: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
			]
		});
	}
	$(window).resize(function(){
		if(window.innerWidth > 992){
			$('.values-content').slick('unslick');
		}else{
			$('.values-content').not('.slick-initialized').slick({
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				variableWidth: true,
				arrows: false,
				mobileFirst: true,
				responsive: [
		
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
				]
			});
		}
	});
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js